<template>
  <v-container fluid>
    <!-- <v-card>           -->
    <v-row align="end" class="white data-inline-content">
      <v-col :cols="is_mobile ? 12 : 6">
        <span class="data-inline-header-content-reference">
          {{ current_qunit.reference }}
        </span>
        <span class="pl-1 data-inline-header-content-title">
          {{ current_qunit.title }}
        </span>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="end data-inline-header" :cols="is_mobile ? 12 : false">
        <v-btn 
          icon
          dense
          @click="copyEmailCode"
          style="width: auto;"
        >
          <!-- <div> -->
          <!-- TODO: Copy code to clipboard -->
          <div class="pa-1" style="white-text: nowrap">
            <small class="data-inline-header-copy" style="display: block">
              {{ $vuetify.lang.translator('inlineboxes.inlinebox_data.copy_email') }}
            </small>
          </div>
          <v-icon right large class="data-inline-header-copy-icon">
            mdi-clipboard-text-multiple
          </v-icon>
          <!-- </div> -->
        </v-btn>
      </v-col>
      <v-col class="data-inline-header" :cols="is_mobile ? 12 : 2">
        <span class="label data-inline-header-label"> {{ $vuetify.lang.translator('inlineboxes.inlinebox_data.responsible') }} </span>
        <span class="data-inline-header-title">
          {{ current_qunit.current_workflow_responsible }}
        </span>
      </v-col>
      <v-col class="data-inline-header" md="auto" :cols="is_mobile ? 12 : false">
        <span class="label data-inline-header-label">{{ $vuetify.lang.translator('limit') }}</span>
        <v-icon
          v-if="
            current_qunit.current_workflow_limit &&
              new Date() >= new Date(current_qunit.current_workflow_limit.value)
          "
          color="#ff0000"
          small
        >
          mdi-alert-circle
        </v-icon>
        <span
          class=""
          v-if="current_qunit.current_workflow_limit"
          v-bind:class="[
            new Date() >= new Date(current_qunit.current_workflow_limit.value)
              ? 'data-inline-header-title-date-plan-late'
              : 'data-inline-header-title',
          ]"
        >
          <!-- {{
            new Date(current_qunit.current_workflow_limit.value).toLocaleDateString(
              (options = { dateStyle: 'short' }),
            )
          }} -->
          {{ current_qunit.current_workflow_limit.short() }}
        </span>
      </v-col>
      <v-col class="data-inline-header-checkbox" v-if="!is_mobile">
        <v-icon
          v-if="check_value"
          class="mr-3"
        >
            mdi-checkbox-marked
        </v-icon>
        <v-icon 
          v-else 
          @click="toogle" 
          class="mr-3"
        >
          mdi-checkbox-blank-outline
        </v-icon>
      </v-col>
    </v-row>
    <v-row :class="is_mobile ? 'data-inline-mobile' : ''">
      <v-expansion-panels multiple v-model="extended">
        <v-expansion-panel
          v-for="panel in props.layout"
          :key="panel.id"
        >
          <v-expansion-panel-header class="data-inline-expand-header">
            <span class="data-inline-expand-title">{{ panel.title }} </span>
            <template v-slot:actions>
              <v-icon 
                class="data-inline-expand-icon"
                @click="changeCheckValue"
              >
                mdi-chevron-down
              </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row v-for="(row, index) in panel.rows" :key="index">
              <v-col
                v-for="(col, index) in row"
                :key="index"
                :cols="is_mobile ? 12 : col.props.cols"
                v-if="!is_mobile || (col.props.label || col.props.value)"
              >
                <div :class="is_mobile ? 'qmkey-flex-box' : ''" >
                  <span class="data-inline-data-title">
                    {{ col.props.label }}
                  </span>
                  <span v-if="is_mobile && col.props.label" class="qmkey-inline-content-mobile">
                    :
                  </span>
                  <div
                    class="qmkey-inline-content-value"
                    :class="
                      col.props.class
                        ? col.props.class
                        : ['data-inline-data', 'text-justify']
                    "
                  >
                    <Field
                      @download-evidence="handleEvidence"
                      :field="col"
                    />
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <!-- </v-card> -->
  </v-container>
</template>

<script>
import Field from '@/components/qfields/Field'

export default {
  name: 'InlineBoxData',

  props: {
    current_qunit: Object,
    props: Object,
    is_mobile: {type: Boolean, default: false},
  },

  components: {
    Field,
  },

  data() {
    return {
      extended: [],
      value: true,
    }
  },
  mounted: function() {
    this.all()
  },
  computed: {
    check_value() {
      // return this.extended.length == this.current_qunit.inline_box_data.length
      return this.extended.length == this.props.layout.length
    },
  },
  methods: {
    // Create an array the length of our items
    // with all values as true
    all() {
      let extend = []
      for (var i = 0; i < this.props.layout.length; i++) {
        extend.push(i)
      }
      this.extended = extend
    },
    // Reset the panel
    none() {
      this.extended = []
    },
    toogle(newValue) {
      // if (newValue == true) {
      //   this.all()
      // }
      this.all()
    },
    changeCheckValue() {
      if (this.value == true) {
        this.value = false
      }
    },
    copyEmailCode() {
      let textToCopy = this.current_qunit.uid
      navigator.clipboard.writeText(textToCopy)
    },
    handleEvidence(field) {
      let params = {
        "qunit_id": this.current_qunit.uid,
        "attribute": field.props.id,
        "value": field.props.value,
        "title": field.props.readable,
        "version": field.props.version,
      };
      // Downloadable bps like dociso document, has each donloadable file into
      // current_state_document attr but other bps just use file field props
      // if (this.current_qunit.current_public_version.value) {
      //   params = this.current_qunit.current_public_version;
      // }
      this.$emit('download-evidence', field);
    },
  },
}
</script>
<style lang="scss">
@import '@/sass/explorer.scss';
.data-inline-mobile {
  font-size: small !important;
}
.qmkey-inline-content-mobile {
  margin-right: 1em;
}
.qmkey-inline-content-value {
  overflow: auto;
}
.qmkey-flex-box {
  display: flex;
}
</style>
